import { useContext, Fragment } from "react"
import { UserContext } from "../../../../../../context/UserContext"
import { useNavigate } from "react-router-dom"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import { styles } from "."
import { Button, Stack, Typography } from "@mui/material"
import { Table, TableBody, TableRow, TableCell } from "@mui/material"
import api from "../../../../../../api/axios"

export default function PlansTable(props) {
    const navigate = useNavigate()
    const { getEmployerPlans, isSeanOrCustomer, isCustomer, refreshUserProfile, setRefreshUserProfile } = useContext(UserContext)
    
    const { onboarding, formatDate } = props
    const plans = getEmployerPlans()

    async function handleUpdate(plan) {
        // console.log("PlansTable handleUpdate called for plan:", plan)
        try {
            const { id } = plan
            setRefreshUserProfile()
            const path = `/employer-flow/plans?onboarding=${onboarding}&step=1&planId=${id}`
            navigate(path)
        } catch (error) {
            console.error(error)
        }
    }

    async function handleDelete(plan) {
        console.log("handleDelete called for plan:", plan)
        try {
            if (window.confirm("Do you really want to delete the plan?")) {
                await api.delete(plan?.links?.delete?.url)
                setRefreshUserProfile()
                await refreshUserProfile()
                const path = `/employer-flow/plans?onboarding=${onboarding}&step=0`
                navigate(path)
            }
        } catch (error) {
            console.error(error)
        }
    }

    async function handleRollover(plan) {
        try {
            if (window.confirm(`Are you sure you want to rollover ${plan?.name}?`)) {
                await api.post(plan?.links?.rollover?.url)
                setRefreshUserProfile()
                await refreshUserProfile()
            }
        } catch (error) {
            console.error(error)
        }
    }

    async function handleClose(plan) {
        try {
            if (window.confirm(`Are you sure you want to close ${plan?.name}?`)) {
                await api.post(plan?.links?.close?.url)
                setRefreshUserProfile()
                await refreshUserProfile()
            }
        } catch (error) {
            console.error(error)
        }
    }

    // Check if user is admin (not Sean or Customer)
    const isAdmin = !isSeanOrCustomer
    const showClose = !isCustomer

    return (
        <Fragment>
            <ThemeProvider theme={createTheme({ components: styles.table })}>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell sx={{ width: "15%" }}>Plan Name</TableCell>
                            <TableCell sx={{ width: "12%" }}>Start Date</TableCell>
                            <TableCell sx={{ width: "12%" }}>End Date</TableCell>
                            <TableCell sx={{ width: "12%" }}>Status</TableCell>
                            <TableCell sx={{ width: "49%", textAlign: "center" }}>Actions</TableCell>
                        </TableRow>
                        {plans?.map((plan) => {
                            let statusColor = "#FF0000" // Red for Incomplete
                            let status = "Incomplete"
                            if (plan?.closedTs) {
                                status = "Closed"
                            } else if (plan?.isComplete) {
                                status = "Complete"
                                statusColor = "#465578" // primary for Complete
                            }

                            // Check if buttons should be enabled
                            const hasRolloverLink = plan?.links?.rollover
                            const hasCloseLink = plan?.links?.close

                            return (
                                <TableRow key={plan?.id}>
                                    <TableCell sx={{ whiteSpace: "nowrap" }}>{plan?.name}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                                        {formatDate ? formatDate(plan?.startDate) : plan?.startDate}
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                                        {formatDate ? formatDate(plan?.endDate) : plan?.endDate}
                                    </TableCell>
                                    <TableCell sx={{ color: statusColor }}>{status}</TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>
                                        <Stack spacing="10px" direction="row" sx={styles.tableActions}>
                                            <Button
                                                onClick={() => handleUpdate(plan)}
                                                variant="contained"
                                                size="small"
                                                sx={{ width: '100px' }}
                                                color="primary"
                                            >
                                                Update
                                            </Button>

                                            {isAdmin && (
                                                <Button
                                                    onClick={() => handleRollover(plan)}
                                                    variant="contained"
                                                    size="small"
                                                    sx={{ width: '100px' }}
                                                    color="secondary"
                                                    disabled={!hasRolloverLink}
                                                >
                                                    Rollover
                                                </Button>
                                            )}

                                            {showClose && (
                                                <Button
                                                    onClick={() => handleClose(plan)}
                                                    variant="contained"
                                                    size="small"
                                                    sx={{ width: '100px' }}
                                                    color="warning"
                                                    disabled={!hasCloseLink}
                                                >
                                                    Close
                                                </Button>
                                            )}

                                            <Button
                                                onClick={() => handleDelete(plan)}
                                                variant="contained"
                                                size="small"
                                                sx={{ width: '100px' }}
                                                color="error"
                                            >
                                                Delete
                                            </Button>
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </ThemeProvider>
        </Fragment>
    )
}
